import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useHistory, useLocation, useParams } from "react-router-dom";

import { CONFERIR_MOVIMENTACOES_TEMPLATE_ID } from "v2/pages/Setup/shared/ActivitySetup/campaigns/types";
import { CAMPAIGN_TYPE_LABEL } from "v2/services/contractLifecycle.service";
import { CampaignMonitor } from "./CampaignMonitor";
import { MonitorableType } from "./monitor.types";
import { parseFilterParam } from "./monitor.utils";

/**
 * why: tipos com monitor, por template (spec §2: a ficha do tipo declara o template). Conferir também
 * oferece a extensão do plano, mas ela não é `MonitorableType` e não ganha aba até entrar no monitor.
 */
export const MONITORED_TYPES_BY_TEMPLATE: Record<string, MonitorableType[]> = {
  [CONFERIR_MOVIMENTACOES_TEMPLATE_ID]: ["contributario"],
};

export function CampaignTypeTabs() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string; templateId: string };
  const { search } = useLocation();
  const history = useHistory();
  const types = MONITORED_TYPES_BY_TEMPLATE[templateId] ?? [];
  const requested = new URLSearchParams(search).get("tipo");
  const current = types.find((t) => t === requested) ?? types[0];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          size="small"
          aria-label="Voltar para Conferir movimentações"
          onClick={() => history.push(`/v2/workspaces/${workspaceId}/templates/${templateId}/movements-check`)}
        >
          <ArrowBack color="primary" />
        </IconButton>
        <Typography variant="h6">Campanhas</Typography>
      </Box>
      <Tabs value={current ?? false} onChange={(_e, value: MonitorableType) => history.replace({ search: `?tipo=${value}` })}>
        {types.map((t) => (
          <Tab key={t} value={t} label={CAMPAIGN_TYPE_LABEL[t]} />
        ))}
      </Tabs>
      {current && (
        <CampaignMonitor
          key={current}
          source={{ kind: "WORKSPACE", workspaceId }}
          type={current}
          initialFilters={parseFilterParam(search)}
        />
      )}
    </Box>
  );
}
